import {BulletPointType} from "../../definitions/types";

export class BulletPointModel {
    private readonly _bulletPoint: BulletPointType;

    constructor(public readonly bulletPoint: BulletPointType) {
        this._bulletPoint = bulletPoint;
    }

    /**
     * @method id
     * @description Returns the id of the bullet point model (unique)
     * @returns {number}
     * @example
     * const bulletPoint = new BulletPointModel({id: 1, title: 'Bullet Point Title', description: 'Bullet Point Description'});
     * console.log(bulletPoint.id); // 1
     */
    public get id(): number {
        return this._bulletPoint.id;
    }

    /**
     * @method title
     * @description Returns the description of the bullet point model
     * @returns {string}
     * @example
     * const bulletPoint = new BulletPointModel({id: 1, title: 'Bullet Point Title', description: 'Bullet Point Description'});
     * console.log(bulletPoint.title); // 'Bullet Point Title'
     */
    public get description(): string {
        return this._bulletPoint.description;
    }
}